import { CustomModal } from "../../../lib/CustomModal";
import { CalendarContainer } from "./CalendarContainer";
import { FormInstance } from "antd";
import { useCallback } from "react";
import "../styles.scss";
import { ScheduleEmailOptions } from "..";

type ScheduleModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  form: FormInstance;
  initialData: any;
  onSchedule: (values: any) => void;
  options?: ScheduleEmailOptions;
};

export const ScheduleModal = ({ open, setOpen, form, initialData, onSchedule, options }: ScheduleModalProps) => {
  const toggleOpen = useCallback(
    (value: boolean) => {
      form.setFieldValue("scheduledDate", undefined);
      setOpen(value);
    },
    [form, setOpen]
  );

  return (
    <CustomModal
      isModalOpen={open}
      titleText="Schedule Send"
      setIsModalOpen={toggleOpen}
      width={328}
      headerClass="processing-print-modal--header"
      modalClass="processing-print-modal schedule"
      destroyOnClose
    >
      <CalendarContainer
        toggleOpen={toggleOpen}
        onSchedule={onSchedule}
        setOpen={setOpen}
        initialData={initialData}
        options={options}
      />
    </CustomModal>
  );
};
